import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "I infiltrated another Rails Girls event, #RailsGirlsMb",
  "description": "",
  "published": "2013-06-04T00:00:00.000Z",
  "redirect_from": ["/blog/i-infiltrated-another-rails-girls-event-railsgirlsmb/swizec/6222"],
  "categories": "Heroku, HTML, Learning, Maribor, Programming, Ruby Rails, Travel + Events",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://www.filepicker.io/api/file/LLvKgLJ7Tf6Qyxcmcloy",
        "alt": "Rails Girls Maribor heart",
        "title": "Rails Girls Maribor heart"
      }}></img><img parentName="p" {...{
        "src": "",
        "alt": null
      }}></img></p>
    <p>{`Last time `}<a parentName="p" {...{
        "href": "http://swizec.com/blog/i-infiltrated-railsgirlsj-heres-what-it-was-like/swizec/5717"
      }}>{`I infiltrated a Rails Girls event`}</a>{` angry internet feminists gave me a lot of flak about volunteering a day to teach girls - sorry, strong independent women aged about 19 and up - about the web and programming and this crazy world of technology I breathe every day.`}</p>
    <p>{`But those harpies are angry about everything, let's not worry about them. Real girls are `}<em parentName="p">{`awesome`}</em>{`. They love learning cool things and don't mind if a guys do the teaching.`}</p>
    <p>{`No idea what I did last time, but I actually got invited to mentor at `}<a parentName="p" {...{
        "href": "http://railsgirls.com/maribor"
      }}>{`Rails Girls Maribor`}</a>{`. Something about having done it once before. Must've been the cool hat, because I was rubbish at it last time. Think the girls spent more time guiding me around than I did them.`}</p>
    <p>{`But off my big mouth went and on Saturday, at 9am sharp, I showed up at the Maribor technical faculty, FERI. Well, no, I was an hour late because I `}<em parentName="p">{`really`}</em>{` hate mornings and Maribor is super far for someone whose daily commute consists of getting out of bed.`}</p>
    <p><img parentName="p" {...{
        "src": "https://www.filepicker.io/api/file/3k8emjdYSw6hNpMPrreU",
        "alt": "Me and my jolly lasses",
        "title": "Me and my jolly lasses"
      }}></img></p>
    <p>{`This time will be different! I have four months of proper rails experience! This time I'll be the awesomest mentor ever and will teach girls all the secret ruby incantations!`}</p>
    <p>{`Fat chance.`}</p>
    <p>{`By far the most unreliable part was the girls' typing. Telling them retyping is better for memorisation than copy pasting was a grave mistake. Not one managed to write `}<inlineCode parentName="p">{`mkdir railsgirls`}</inlineCode>{`. We had two railgirls and one prailsgirls.`}</p>
    <p>{`Another missed half the line for scaffolding generation and `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Bracket",
        "title": "Bracket"
      }}>{`curly braces`}</a>{` were forever the bane of carefully painted nails. Copy pasting worked much better and two of the girls got through the main guide before lunch.`}</p>
    <p>{`Yay!`}</p>
    <p>{`Unfortunately we had to concede defeat with one of the girls. Four mentors tried to solve the problem. All were defeated. Windows 8, it seems, does not play well with `}<a parentName="p" {...{
        "href": "http://rubyonrails.org",
        "title": "Ruby on Rails"
      }}>{`Ruby on Rails`}</a>{` and we simply could not install some needed dependencies ... no `}<a parentName="p" {...{
        "href": "http://www.python.org/",
        "title": "Python (programming language)"
      }}>{`Python`}</a>{`. Yep.`}</p>
    <p>{`In the end, none of my Rails experience did any good. The girls were far more interested in tweaking the visuals. But then, you can't really learn to code in an afternoon. But you can learn to learn. By far the biggest win was showing them how to use Bootstrap documentation, `}<a parentName="p" {...{
        "href": "http://www.google.com/chrome",
        "title": "Google Chrome"
      }}>{`Chrome`}</a>{` console and poking around the `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/HTML",
        "title": "HTML"
      }}>{`HTML`}</a>{`, to figure things out on their own.`}</p>
    <p>{`Nothing like teaching someone how to teach themselves. Then you get to play with your phone instead of being chirpy and communicative when the caffeine content in your blood runs out ... I wish event organisers stopped forgetting some of us like tea, not coffee.`}</p>
    <p>{`The girls and I also discovered a bug with the Rails Girls Guide thingy - when you put your site on `}<a parentName="p" {...{
        "href": "http://www.heroku.com/",
        "title": "Heroku"
      }}>{`Heroku`}</a>{`, image uploads stop working because they rely on local disk persistency and Heroku doesn't really `}<em parentName="p">{`do`}</em>{` that. Rather a big shame - my whole group left soon after that.`}</p>
    <p>{`Or I was just boring.`}</p>
    <p>{`But all in all, a smashing success! If at least some of the girls use their new-found knowledge for more than just understanding their boyfriends better, the programming world will be a better place.`}</p>
    <p>{`Can't wait to do this again!`}</p>
    <p><em parentName="p">{`PS: both images taken from `}<a parentName="em" {...{
          "href": "https://twitter.com/railsgirlsmb"
        }}>{`@RailsGirlsMb`}</a>{` twitter stream`}</em></p>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=c3911d06-d977-4af7-b647-35b517979806",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      